var _path, _path2, _path3, _path4, _rect, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNetworkPolicyinline = function SvgNetworkPolicyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0080FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M40 65s22-7.25 22-29V16s-6.907-1.915-11-3.329C46.11 10.983 40 7 40 7s-6.11 3.983-11 5.671C24.907 14.085 18 16 18 16v20c0 21.75 22 29 22 29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E0E5EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M69 23v12.395C69 63.6 40 73 40 73s-29-9.401-29-37.604V23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25 28v-6s4.71-1.114 7.5-2.089C35.834 18.747 40 16 40 16s4.166 2.747 7.5 3.911C50.29 20.886 55 22 55 22v6m-30 0v8c0 15 15 20 15 20s15-5 15-20v-8m-30 0c3.333 0 12.222-2.778 15-5 2.778 2.222 11.667 5 15 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32.5 19.84C35.834 18.697 40 16 40 16s4.166 2.697 7.5 3.84c2.79.957 7.5 2.05 7.5 2.05V28c-3.333 0-12.222-2.727-15-4.91C37.222 25.274 28.333 28 25 28v-6.11s4.71-1.093 7.5-2.05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    x: 34,
    y: 38,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2,
    rx: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2,
    d: "M37 35a3 3 0 1 1 6 0v3h-6z"
  })));
};
export default SvgNetworkPolicyinline;